import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnRequestedUser extends SnModel {
  @Expose()
  public email: string;

  @Expose()
  public mobilePhone: string;

  @Expose()
  public firstName: string;

  @Expose()
  public lastName: string;

  @Expose()
  public organization: string;

  @Expose()
  public prefix: string;

  @Expose()
  public externalOrganization: string;

  @Expose()
  public referrer: string;

  @Expose()
  public externalOrganizationTitle: string;

  @Expose()
  public notes: string;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
